import { ModalService, SimpleMessageService, WebAppCommonModule } from "@allbesmart/web-app-common";
import { Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { OrderDto } from "src/app/models/order-dto";
import { OrderService } from "src/app/services/order.service";
import { OrderDetailsComponent } from "../order-details/order-details.component";

@Component({
    selector: "oaibox-delete-order-warning-modal",
    templateUrl: "./delete-order-warning-modal.component.html",
    styleUrl: "./delete-order-warning-modal.component.css",
    imports: [WebAppCommonModule, OrderDetailsComponent],
})
export class DeleteOrderWarningModalComponent implements OnDestroy {
  @Input({ required: true }) public order!: OrderDto;

  private deleteOrderSubscription?: Subscription;

  constructor(
    private readonly orderService: OrderService,
    private readonly simpleMessageService: SimpleMessageService,
    private readonly modalService: ModalService
  ) {}

  protected deleteOrder(): void {
    this.deleteOrderSubscription = this.orderService
      .deleteOrder(this.order.id)
      .subscribe({
        next: () => {
          this.orderService.refreshOrders();
          this.simpleMessageService.showSimpleMessage({
            message: "Order deleted successfully!",
            icon: "fa-solid fa-check-double",
            color: "success",
          });
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: "Failed to delete order",
            icon: "fa-solid fa-triangle-exclamation",
            color: "danger",
          });
          this.modalService.popModal();
        },
      });
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.deleteOrderSubscription?.unsubscribe();
  }
}
